"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault")["default"];
var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard")["default"];
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _regeneratorRuntime2 = _interopRequireDefault(require("@babel/runtime/helpers/regeneratorRuntime"));
var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));
var _objectSpread2 = _interopRequireDefault(require("@babel/runtime/helpers/objectSpread2"));
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireWildcard(require("react"));
var _clsx = _interopRequireDefault(require("clsx"));
var _Paper = _interopRequireDefault(require("../Paper"));
var _context3 = _interopRequireDefault(require("../Theme/context"));
var _enterNextFocus = _interopRequireDefault(require("./enterNextFocus"));
var _excluded = ["classNames", "disableUseStyle", "disabled", "onChange", "onBlur", "PaperComponent", "PaperProps", "effect", "containerRef", "className", "parentButtonPaperDisabled", "InputComponent", "minRows", "maxRows", "preventIosScrollOnFocus", "manualScrollIntoView"],
  _excluded2 = ["value"];
var _default = exports["default"] = /*#__PURE__*/_react["default"].forwardRef(function (props, _ref3) {
  var classNames = props.classNames,
    disableUseStyle = props.disableUseStyle,
    disabled = props.disabled,
    onChange = props.onChange,
    onBlur = props.onBlur,
    _props$PaperComponent = props.PaperComponent,
    PaperComponent = _props$PaperComponent === void 0 ? _Paper["default"] : _props$PaperComponent,
    _props$PaperProps = props.PaperProps,
    PaperProps = _props$PaperProps === void 0 ? {} : _props$PaperProps,
    effect = props.effect,
    containerRef = props.containerRef,
    className = props.className,
    parentButtonPaperDisabled = props.parentButtonPaperDisabled,
    _props$InputComponent = props.InputComponent,
    InputComponent = _props$InputComponent === void 0 ? 'input' : _props$InputComponent,
    _props$minRows = props.minRows,
    minRows = _props$minRows === void 0 ? InputComponent === 'textarea' ? 4 : 0 : _props$minRows,
    _props$maxRows = props.maxRows,
    maxRows = _props$maxRows === void 0 ? minRows : _props$maxRows,
    preventIosScrollOnFocus = props.preventIosScrollOnFocus,
    _props$manualScrollIn = props.manualScrollIntoView,
    manualScrollIntoView = _props$manualScrollIn === void 0 ? preventIosScrollOnFocus ? {} : null : _props$manualScrollIn,
    rest2 = (0, _objectWithoutProperties2["default"])(props, _excluded);
  var variant = PaperProps.variant,
    color = PaperProps.color;
  var value = rest2.value,
    rest = (0, _objectWithoutProperties2["default"])(rest2, _excluded2);
  if (!value) {
    value = value ? value.toString() : '';
  }
  var themeContext = (0, _react.useContext)(_context3["default"]);
  var useStyle = themeContext.useStyle;
  if (typeof useStyle === 'function' && !disableUseStyle) {
    useStyle(classNames);
  }
  var _useState = (0, _react.useState)(value),
    _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
    inputValue = _useState2[0],
    setValue = _useState2[1];
  var inputRef = (0, _react.useRef)();
  (0, _react.useEffect)(function () {
    if (effect) {
      effect({
        actions: {
          setValue: setValue,
          getValue: function getValue() {
            return value;
          },
          focus: function focus() {
            if (inputRef.current) {
              if (preventIosScrollOnFocus) {
                inputRef.current.style.opacity = 0;
              }
              if (manualScrollIntoView) {
                inputRef.current.focus({
                  preventScroll: true
                });
                inputRef.current.scrollIntoView({
                  block: 'center'
                });
              } else {
                inputRef.current.focus();
              }
              if (preventIosScrollOnFocus) {
                setTimeout(function () {
                  inputRef.current.style.opacity = 1;
                }, 300);
              }
            }
          }
        }
      });
    }
    return function () {
      if (effect) {
        effect({
          actions: {
            setValue: function setValue() {},
            getValue: function getValue() {},
            focus: function focus() {}
          }
        });
      }
    };
  });
  (0, _react.useEffect)(function () {
    function setTextareaHeight() {
      var _inputRef$current;
      if (InputComponent === 'textarea' && (_inputRef$current = inputRef.current) !== null && _inputRef$current !== void 0 && _inputRef$current.scrollHeight) {
        inputRef.current.style.height = 'auto';
        inputRef.current.style.height = inputRef.current.scrollHeight + 20 + 'px';
      }
    }
    setTextareaHeight();
    var t = setTimeout(function () {
      setTextareaHeight();
    }, 100);
    return function () {
      if (t) {
        clearTimeout(t);
      }
    };
  }, []);
  return /*#__PURE__*/_react["default"].createElement(PaperComponent, Object.assign({
    size: 'none',
    elevation: 0,
    disabled: disabled
  }, PaperProps, {
    color: color,
    variant: variant !== 'contained' ? 'text' : variant,
    className: (0, _clsx["default"])(classNames.textBasePaper, className, PaperProps.className)
  }), /*#__PURE__*/_react["default"].createElement(InputComponent, Object.assign({
    type: 'text'
  }, rest, minRows ? {
    style: (0, _objectSpread2["default"])({
      '--digby-input-textarea-rows': minRows,
      '--digby-input-textarea-max-rows': maxRows
    }, rest.style ? rest.style : {}),
    rows: minRows
  } : {}, {
    disabled: disabled,
    className: (0, _clsx["default"])(classNames.textBase, rest.className),
    onChange: ( /*#__PURE__*/function () {
      var _ref = (0, _asyncToGenerator2["default"])( /*#__PURE__*/(0, _regeneratorRuntime2["default"])().mark(function _callee(e) {
        var _e$target2;
        var _e$target, _e$target3, _e$target4;
        return (0, _regeneratorRuntime2["default"])().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              e.preventDefault();
              if (!setValue) {
                _context.next = 4;
                break;
              }
              _context.next = 4;
              return setValue((_e$target = e.target) === null || _e$target === void 0 ? void 0 : _e$target.value);
            case 4:
              if (InputComponent === 'textarea' && (_e$target2 = e.target) !== null && _e$target2 !== void 0 && _e$target2.scrollHeight) {
                e.target.style.height = 'auto';
                e.target.style.height = e.target.scrollHeight + 'px';
              }
              if (!onChange) {
                _context.next = 8;
                break;
              }
              _context.next = 8;
              return onChange(e, (_e$target3 = e.target) === null || _e$target3 === void 0 ? void 0 : _e$target3.value);
            case 8:
              if (!(e.target !== document.activeElement)) {
                _context.next = 12;
                break;
              }
              if (!onBlur) {
                _context.next = 12;
                break;
              }
              _context.next = 12;
              return onBlur(e, (_e$target4 = e.target) === null || _e$target4 === void 0 ? void 0 : _e$target4.value);
            case 12:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }));
      return function (_x) {
        return _ref.apply(this, arguments);
      };
    }()),
    onBlur: ( /*#__PURE__*/function () {
      var _ref2 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/(0, _regeneratorRuntime2["default"])().mark(function _callee2(e) {
        var _e$target5;
        return (0, _regeneratorRuntime2["default"])().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              if (!onBlur) {
                _context2.next = 3;
                break;
              }
              _context2.next = 3;
              return onBlur(e, (_e$target5 = e.target) === null || _e$target5 === void 0 ? void 0 : _e$target5.value);
            case 3:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      }));
      return function (_x2) {
        return _ref2.apply(this, arguments);
      };
    }()),
    ref: function ref(e) {
      inputRef.current = e;
      if (_ref3) {
        if (typeof _ref3 === 'function') {
          _ref3(e);
        } else if (_ref3 && typeof _ref3 === 'object') {
          _ref3.current = e;
        }
      }
    },
    onKeyDown: function onKeyDown(e) {
      if (InputComponent === 'textarea') {} else {
        (0, _enterNextFocus["default"])(e, manualScrollIntoView);
      }
    },
    value: inputValue
  })));
});